import { Currency } from "./currency.type";

export enum ClientType {
  SALE = "Продажа",
  PURCHASE = "Покупка",
  LOM = "Лом",
}

export interface Client {
  _id: string;
  name: string;
  phone: string;
  totalSoldAmount: number;
  totalPurchasedAmount: number;
  totalPaidAmount: number;
  totalReceivedAmount: number;
  ownerId: string;
  ownerName: string;
  clientType: ClientType;
  debtCurrency: Currency;
  totalClientDebt: number;
  totalCompanyDebt: number;
  spoolDebt: number;
  // Telegram-контакт для отправки чеков/квитанций
  telegram?: string; // введённый номер / chatId / @username
  telegramChatId?: string; // резолвнутый адрес Green API
  telegramLinked?: boolean; // писал ли клиент нам (иначе чек не уйдёт)
  receiptsEnabled?: boolean; // слать ли чеки этому клиенту
  telegramLastError?: string;
  createdAt: string;
  updatedAt: string;
}
